import { throttle } from "es-toolkit";
import { useEffect, useState } from "react";

export type MousePosition = {
  x: number;
  y: number;
};

export const useMousePosition = (containerRef?: HTMLElement | SVGSVGElement, zoom = 1, offset = { x: 0, y: 0 }) => {
  const [mousePosition, setMousePosition] = useState<MousePosition>();

  useEffect(() => {
    if (!containerRef) return;

    const containerCoordinates = containerRef.getBoundingClientRect();

    const updateMousePosition = throttle(
      ({ clientX, clientY }: MouseEvent) =>
        setMousePosition({
          x: (clientX - containerCoordinates.x) / zoom + offset.x,
          y: (clientY - containerCoordinates.y) / zoom + offset.y,
        }),
      50,
    );

    window.addEventListener("mousemove", updateMousePosition);

    return () => {
      window.removeEventListener("mousemove", updateMousePosition);
      updateMousePosition.cancel();
    };
  }, [containerRef, offset, zoom]);

  return mousePosition;
};
